import "$styles/index.css"
import "$styles/itineraries.css"
import "$styles/contact.css"
import "$styles/navbar.css"
import "$styles/carousel.css"
import "$styles/tours.css"
import "$styles/testimonials.css"
import "$styles/news.css"
import "$styles/footer.css"
import "$styles/blogpost.css"
import "$styles/stanzas.css"
import { Application } from "@hotwired/stimulus"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")

window.Stimulus = Application.start()

import controllers from "./controllers/**/*.{js,js.rb}"
Object.entries(controllers).forEach(([filename, controller]) => {
  if (filename.includes("_controller.") || filename.includes("-controller.")) {
    const identifier = filename.replace("./controllers/", "")
      .replace(/[_-]controller\..*$/, "")
      .replace(/_/g, "-")
      .replace(/\//g, "--")

    Stimulus.register(identifier, controller.default)
  }
})
